
export function content() {


	$(function(){

		// load scrollで実行
		$(window).on('load scroll', function() {
			var y  = $(window).scrollTop();
			var h  = $(window).innerHeight();
			// fade animation
			$('.js-fadeup').each(function() {
				if ( ( y + ( h * 0.85 ) ) > $(this).offset().top ) {
					$(this).addClass('is-show');
				};
			});
		
			if ( $('body.home')[0]) {
				// Homepageのみ
				var trigger = $('.js-trigger').offset().top;
				// ページトップ出現
				if ( y > trigger ) {
					$('.umegle-btn').addClass('is-show');
					$('.totop').addClass('is-show');
				} else {
					$('.umegle-btn').removeClass('is-show');
					$('.totop').removeClass('is-show');
				}
			} else {
				if ( y > 50 ) {
					$('.totop').addClass('is-show');
				} else {
					$('.totop').removeClass('is-show');
				}
			}
		});

		$('.gallery').modaal({
			type: 'image'
		});


	});

}
